import type { MaterialIconFragment } from '@/utils/dato/generated';

const sizeClasses: Record<string, string> = {
  'extra-large': 'text-7xl!',
  default: 'text-2xl!',
  large: 'text-6xl!',
  small: 'text-xl!',
};

const MaterialIcon = ({ iconName, size }: MaterialIconFragment) => (
  <span className={`material-symbols-outlined mb-5 text-secondary ${sizeClasses[size]}`}>{iconName}</span>
);

export default MaterialIcon;
